const InventoryStatistics = () => {
  const inventory = [
    { id: 1, name: "Product A", expected: 100, actual: 95, turnoverRate: 5 },
    { id: 2, name: "Product B", expected: 200, actual: 210, turnoverRate: 10 },
  ];

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">庫存量統計</h2>
      <table className="table-auto w-full text-left">
        <thead>
          <tr>
            <th>商品名稱</th>
            <th>預計庫存</th>
            <th>實際庫存</th>
            <th>庫存週轉率</th>
          </tr>
        </thead>
        <tbody>
          {inventory.map((item) => (
            <tr key={item.id} className="border-t">
              <td>{item.name}</td>
              <td>{item.expected}</td>
              <td>{item.actual}</td>
              <td>{item.turnoverRate}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryStatistics;
